import { Toast } from '@common-web/index.js';
import { cpBaseUrl, GET, POST, PUT, RESPONSE_TYPES, CALLEE_TYPES } from '@constants/generic-constants.js';
import { ACTION_INDEX, PERMISSION_KEY_REASON } from '@constants/permission-constants.js';
import PermissionsHelper from 'auth/helper/PermissionHelper.js';
import NetworkManager from '../../services/network-service.js';

export const transactionHistoryListingApi = (params = '') => {
  return new Promise((resolve, reject) => {
    const url = `${cpBaseUrl}/orders/transaction_history${params}`;
    NetworkManager.performRequest(url, null, GET)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const cpOrdersListingApi = (params = '') => {
  return new Promise((resolve, reject) => {
    const url = `${cpBaseUrl}/orders${params}`;
    NetworkManager.performRequest(url, null, GET)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const cpBulkActionApi = ({ url, method, payload }) => {
  return new Promise((resolve, reject) => {
    NetworkManager.performRequest(url, payload, method)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const cpCartsListingApi = (params = '') => {
  return new Promise((resolve, reject) => {
    const url = `${cpBaseUrl}/carts${params}`;
    NetworkManager.performRequest(url, null, GET)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const cpLoadSheetApi = (params = '') => {
  const url = `${cpBaseUrl}/orders/load_sheet${params}`;
  return new Promise((resolve, reject) => {
    NetworkManager.performRequest(url, null, GET, null, RESPONSE_TYPES?.blob)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const orderDetailApi = (id = '') => {
  return new Promise((resolve, reject) => {
    const url = `${cpBaseUrl}/orders/${id}`;
    NetworkManager.performRequest(url, null, GET)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const markPayoutVerifiedApi = (id = '') => {
  return new Promise((resolve, reject) => {
    const url = `${cpBaseUrl}/fulfillments/${id}/mark_verified`;
    NetworkManager.performRequest(url, null, PUT)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const fetchPayoutStatusApi = (params = '') => {
  return new Promise((resolve, reject) => {
    const url = `${cpBaseUrl}/fulfillments/statuses${params}`;
    NetworkManager.performRequest(url, null, GET)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const uploadFulfillmentSheetApi = (body) => {
  return new Promise((resolve, reject) => {
    const url = `${cpBaseUrl}/fulfillments/payments/import`;
    NetworkManager.performRequest(url, body, POST)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const validateFulfillmentSheetApi = (body) => {
  return new Promise((resolve, reject) => {
    const url = `${cpBaseUrl}/fulfillments/payments/validate`;
    NetworkManager.performRequest(url, body, POST)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const courierServicesListingApi = (params = '') => {
  return new Promise((resolve, reject) => {
    const url = `${cpBaseUrl}/courier_services${params}`;
    NetworkManager.performRequest(url, null, GET)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const getCpCancelReasonsApi = (params = '') => {
  return new Promise((resolve, reject) => {
    if (!PermissionsHelper.getPermissions(PERMISSION_KEY_REASON, ACTION_INDEX)) {
      return Toast.error('You are not authorized to fetch reasons');
    }
    const url = `${cpBaseUrl}/reasons${params}`;
    NetworkManager.performRequest(url, null, GET)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const updateCpOrderAddressApi = (orderId, payload) => {
  return new Promise((resolve, reject) => {
    const url = `${cpBaseUrl}/orders/${orderId}/update_address`;
    NetworkManager.performRequest(url, payload, PUT)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const getPaymentsSummaryApi = (params) => {
  return new Promise((resolve, reject) => {
    const url = `${cpBaseUrl}/orders/payments_summary${params}`;
    NetworkManager.performRequest(url, null, GET)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const getTodayOrdersStatsApi = (params = '') => {
  return new Promise((resolve, reject) => {
    const url = `${cpBaseUrl}/orders/order_stats${params}`;
    NetworkManager.performRequest(url, null, GET)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const getAverageOrderDaysApi = (params = '') => {
  return new Promise((resolve, reject) => {
    const url = `${cpBaseUrl}/dashboard/average_delivery_time${params}`;
    NetworkManager.performRequest(url, null, GET)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const cpReturnOrdersListingApi = (params = '') => {
  return new Promise((resolve, reject) => {
    const url = `${cpBaseUrl}/returns${params}`;
    NetworkManager.performRequest(url, null, GET)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const initiateOrderCallApi = (id, payload = { callee_type: CALLEE_TYPES.BUYER }) => {
  return new Promise((resolve, reject) => {
    const url = `${cpBaseUrl}/orders/${id}/push_call_notification`;
    NetworkManager.performRequest(url, payload, PUT)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const cpReturnOrderDetailApi = (id = '') => {
  return new Promise((resolve, reject) => {
    const url = `${cpBaseUrl}/returns/${id}`;
    NetworkManager.performRequest(url, null, GET)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const markReturnAmountSettledApi = ({ payload, url, method }) => {
  return new Promise((resolve, reject) => {
    NetworkManager.performRequest(url, payload, method)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const addAdvancePaymentApi = (payload) => {
  return new Promise((resolve, reject) => {
    const url = `${cpBaseUrl}/payments`;
    NetworkManager.performRequest(url, payload, POST)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const updateCpOrderApi = (id, payload) => {
  return new Promise((resolve, reject) => {
    const url = `${cpBaseUrl}/orders/${id}`;
    NetworkManager.performRequest(url, payload, PUT)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const generateRefundPdfApi = (orderId) => {
  return new Promise((resolve, reject) => {
    const url = `${cpBaseUrl}/orders/${orderId}/generate_refund_pdf`;
    NetworkManager.performRequest(url, null, GET, undefined, RESPONSE_TYPES?.blob)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
export const initiateCartCallApi = (id) => {
  return new Promise((resolve, reject) => {
    const url = `${cpBaseUrl}/carts/${id}/push_call_notification`;
    NetworkManager.performRequest(url, null, PUT)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
